import { Box, HStack } from "@chakra-ui/react"

const SellPagesFooter=()=>{
    return(
        <HStack bg="#002F34" h="38px" w="100%" color="white" spacing="50px" justifyContent="space-around" alignItem="centre" fontSize="10px">
        <Box>Other Countries Pakistan - South Africa - Indonesia</Box>
        <Box>Free Classifieds in India. © 2006-2022 OLX</Box>
       </HStack>    )
}
export default SellPagesFooter